import {wdiCore, WdiInput, WdiModalAppResult, WdiModalProps} from "@/components/WdiControls";
import {WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {WdiSelect, WdiSelectFormat} from "@/components/WdiControls/WdiSelect";
import {ResponseStatus} from "@/utils/request";
import {DatePicker, Form, Input} from "antd";
import {useEffect, useRef, useState} from "react";
import {ProFormInstance} from "@ant-design/pro-form";
import {
  defaultPolicySoldToDateArr,
  soldToDataLoading,
  soldToGroupDataLoading
} from "@/pages/policy/ProductPolicyApply/data";
import moment from "moment/moment";
import {Accrual} from "@/services/sales/financial/accrual";
import {OpenModeEnum} from "@/pages/policy/ProductPolicyApply/components/apply";
import {ModalTypeEnums} from "@/pages/policy/ProductPolicyApply/components/SoldTo/soldTo";

export type WdiModalProductPolicyProps = {
  onClose?: (result?: WdiModalAppResult) => void;
  onSave?: (result?: WdiModalAppResult) => void;
  productPolicy?: API.ProductPolicy;
  openMode: OpenModeEnum
} & WdiModalProps;

const ProductPolicySoldToEditPanel: React.FC<WdiModalProductPolicyProps> = (props) => {
  const formRef = useRef<ProFormInstance>();

  const [disabled, setDisabled] = useState(false);
  const [startDateDisabled, setStartDateDisabled] = useState(false);
  const [endDateDisabled, setEndDateDisabled] = useState(false);


  useEffect(() => {
    if (props.data && props.productPolicy) {
      if(props.openMode==OpenModeEnum.UPDATE_PARTLY){
        Accrual.currentAccrualYmByBohqId(props.productPolicy.bohqId ?? 0).then(responseAccrual => {
          const fPeriod = responseAccrual?.data;
          const startDate = moment(props.data.startDate, "YYYY-MM-DD");
          const endDate = moment(props.data.endDate, "YYYY-MM-DD");
          const fPeriodDate = moment(String(fPeriod), "YYYYMM");
          if (!defaultPolicySoldToDateArr.includes(startDate.format("YYYY-MM-DD")) && startDate.isBefore(fPeriodDate)) {
            setStartDateDisabled(true);
          }
          if (!defaultPolicySoldToDateArr.includes(endDate.format("YYYY-MM-DD")) && endDate.isBefore(fPeriodDate)) {
            setEndDateDisabled(true);
          }
        })
      }


      formRef.current?.setFieldsValue(props.data);
      if (props.data.soldToCode) {
        formRef.current?.setFieldsValue({
          soldToCode: {
            value: props.data.soldToCode,
            label: wdiCore.String.CodeOrName(props.data.soldToCode, props.data.soldToName)
          }
        });
      }

      if (props.data.soldToGroupId) {
        formRef.current?.setFieldsValue({
          soldToGroupId: {
            value: props.data.soldToGroupId,
            label: wdiCore.String.CodeOrName(props.data.soldToGroupCode, props.data.soldToGroupName)
          }
        });
      }
      if (props.data.startDateShow) {
        formRef.current?.setFieldsValue({
          startDateShow: moment(props.data.startDate, "YYYY-MM-DD")
        });
      }
      if (props.data.endDateShow) {
        formRef.current?.setFieldsValue({
          endDateShow: moment(props.data.endDate, "YYYY-MM-DD")
        });
      }

      setDisabled(true);
    }
  }, [props.openMode]);

  return (
    <>
      <WdiModalForm
        formRef={formRef}
        labelCol={{span: 6}}
        wrapperCol={{span: 12}}
        labelAlign='left'
        layout="horizontal"
        title={props.title}
        visible={props.visible}
        preserve={true}
        modalProps={{
          onCancel: () => {
            props.onClose ? props.onClose() : null
          },
          destroyOnClose: true,
          maskClosable: false,
        }}
        onFinish={async (values) => {
          const {soldToCode, soldToGroupId, endDateShow, startDateShow, startDate, endDate, ...entity} = values;
          entity.openMode = props.openMode;
          entity.soldToCode = WdiSelectFormat.getvalue(soldToCode);
          entity.soldToGroupId = WdiSelectFormat.getvalue(soldToGroupId);
          entity.startDate = startDateShow ? moment(startDate).format("YYYY-MM-DD") : "1900-01-01";
          entity.endDate = endDateShow ? moment(endDate).format("YYYY-MM-DD") : "2999-01-01";
          entity.endDateShow = endDateShow ? moment(endDateShow).format("YYYY-MM-DD") : null;
          entity.startDateShow = startDateShow ? moment(startDateShow).format("YYYY-MM-DD") : null;
          const response: API.ResponseResult<any> = {code: ResponseStatus.SUCCESS, data: entity, message: ""};
          if (props.onSave) {
            props.onSave(response);
          }
        }}
      >

        <Form.Item
          name="soldToCode"
          label="客户"
          rules={[{required: false, message: '请选择客户!'}]}>
          <WdiSelect
            {...{
              disabled: disabled,
              placeholder: "请选择客户",
              showSearch: true,
              remote: true,
              defaultParamKey: "soldToCode",
              dataLoading: (params: API.SoldToSearchParam) => {
                return soldToDataLoading(params)
              }
            }
            }
          />
        </Form.Item>

        <Form.Item
          name="soldToGroupId"
          label="返利客户组"
          rules={[{required: false, message: '请选择返利客户组!'}]}>
          <WdiSelect
            {...{
              disabled: disabled,
              placeholder: "请选择返利客户组",
              showSearch: true,
              remote: true,
              defaultParamKey: "soldToGroupId",
              dataLoading: (params: API.SoldToGroupParam) => {
                return soldToGroupDataLoading(params)
              }
            }}
          />
        </Form.Item>

        <Form.Item
          name="startDateShow"
          label="开始日期"
          rules={[{required: ModalTypeEnums.Insert == props.type && OpenModeEnum.UPDATE_PARTLY == props.openMode, message: '请选则适用开始日期!'}]}
        >
          <DatePicker picker="date" format={'YYYY-MM-DD'} disabled={startDateDisabled}/>
        </Form.Item>
        <Form.Item name="startDate" label="开始日期修改前" hidden={true}>
          <Input></Input>
        </Form.Item>

        <Form.Item name="endDateShow" label="截止日期" rules={[{required: false, message: '请选则适用截止日期!'}]}>
          <DatePicker picker="date" format={'YYYY-MM-DD'} disabled={endDateDisabled}/>
        </Form.Item>
        <Form.Item name="endDate" label="截止日期修改前" hidden={true}>
          <Input></Input>
        </Form.Item>

        <Form.Item name="remark" label="备注" rules={[{required: false, message: '请填写备注!'}]}>
          <WdiInput/>
        </Form.Item>
        <Form.Item name="productPolicySoldToId" label="ID" hidden={true}> <WdiInput/> </Form.Item>
        <Form.Item name="uid" label="uid" hidden={true}> <WdiInput hidden={true}/> </Form.Item>
      </WdiModalForm>
    </>
  );
};

export default ProductPolicySoldToEditPanel;
